import { render } from "./video-item.vue?vue&type=template&id=3955edde"
import script from "./video-item.vue?vue&type=script&lang=js"
export * from "./video-item.vue?vue&type=script&lang=js"
script.render = render

export default script